import s from './About.scss'

const openImage = src => {
  window.open(src, '_blank')
}

const About = () => {
  return (
    <section className={s.aboutContainer}>
      <h2>iDeal Construction CRM</h2>
      <p>
        iDeal CRM is the most robust sales software for construction. Prioritize your opportunities,
        bids, and jobs. Create professional proposals. Automate emails and follow-up. Manage leads
        and clients in one place. Bring everything together into actionable reports.
      </p>
      <div className={s.aboutSectionContainer}>
        <div className={s.aboutSection}>
          <div className={s.sectionImage}>
            <img
              onClick={() =>
                openImage(
                  'https://idealcrm.app/wp-content/uploads/Sales-Pipeline-Board-in-iDeal-CRM.jpg'
                )
              }
              src="https://idealcrm.app/wp-content/uploads/Sales-Pipeline-Board-in-iDeal-CRM.jpg"
            />
          </div>
          <p>
            Your entire sales funnel in one glance. Visual pipeline board prioritizes opportunities
            & jobs.
          </p>
        </div>
        <div className={s.aboutSection}>
          <div className={s.sectionImage}>
            <img
              onClick={() =>
                openImage(
                  'https://idealcrm.app/wp-content/uploads/Construction-Proposal-Software-in-iDeal-Construction-CRM.jpg'
                )
              }
              src="https://idealcrm.app/wp-content/uploads/Construction-Proposal-Software-in-iDeal-Construction-CRM.jpg"
            />
          </div>
          <p>Proposal Software helps you create professional proposals, send, and track them.</p>
        </div>
        <div className={s.aboutSection}>
          <div className={s.sectionImage}>
            <img
              onClick={() =>
                openImage(
                  'https://idealcrm.app/wp-content/uploads/Construction-Calendar-with-bids-leads-followup-tasks-events.jpg'
                )
              }
              src="https://idealcrm.app/wp-content/uploads/Construction-Calendar-with-bids-leads-followup-tasks-events.jpg"
            />
          </div>
          <p>All-in-one bids, follow-ups, tasks, and events calendar for your entire sales team.</p>
        </div>
        <div className={s.aboutSection}>
          <div className={s.sectionImage}>
            <img
              onClick={() =>
                openImage(
                  'https://idealcrm.app/wp-content/uploads/iDeal-Construction-CRM-Follow-up-Tool-and-Automation.jpg'
                )
              }
              src="https://idealcrm.app/wp-content/uploads/iDeal-Construction-CRM-Follow-up-Tool-and-Automation.jpg"
            />
          </div>
          <p>The iDeal follow-up tool prioritizes and automates your follow-up.</p>
        </div>
        <div className={s.aboutSection}>
          <div className={s.sectionImage}>
            <img
              onClick={() =>
                openImage(
                  'https://idealcrm.app/wp-content/uploads/Lead-Management-in-iDeal-CRM.jpg'
                )
              }
              src="https://idealcrm.app/wp-content/uploads/Lead-Management-in-iDeal-CRM.jpg"
            />
          </div>
          <p>Turn on the Leads module to capture, organize, and prioritize all your leads.</p>
        </div>
        <div className={s.aboutSection}>
          <div className={s.sectionImage}>
            <img
              onClick={() =>
                openImage(
                  'https://idealcrm.app/wp-content/uploads/Construction-Reports-for-Sales-Teams-Executives-and-Owners.jpg'
                )
              }
              src="https://idealcrm.app/wp-content/uploads/Construction-Reports-for-Sales-Teams-Executives-and-Owners.jpg"
            />
          </div>
          <p>Built-in sales reports bring meaningful, actionable data to the table.</p>
        </div>
      </div>
    </section>
  )
}

export default About
